export default "__VITE_ASSET__BuYjHr$T__"